export function CitiLogo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 39 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.1905 28.1113C9.91695 31.5677 5.64009 28.5103 5.64009 25.1703C5.64009 22.4614 7.75879 21.0822 9.57836 20.9495C11.302 20.8239 12.6913 22.013 13.1677 22.5448L14.7463 20.6504C13.3255 19.0135 11.9878 18.3238 9.7113 18.3238C5.77302 18.3238 2.81519 21.2007 2.81519 25.6023C2.81519 29.8597 5.97646 31.8004 8.70596 32.2656C10.4084 32.5558 12.0062 32.0393 12.37 31.867C13.4681 31.347 14.4486 30.4689 14.7587 30.0036C14.371 29.5439 13.5228 28.5101 13.1905 28.1113Z"
        fill="currentColor"
      />
      <path
        d="M26.6774 18.523V14.3188L23.9189 15.7812V18.523H21.6091V21.1152H23.9189V28.5929C23.9189 31.8167 26.021 32.2902 27.3337 32.2902C28.3839 32.2902 29.2309 31.8582 29.4857 31.6588L30.1171 29.0915C27.4916 30.6701 26.6719 29.4155 26.6774 28.7009V21.1152H29.4857V18.523H26.6774Z"
        fill="currentColor"
      />
      <path
        opacity="0.5"
        d="M17.7042 16.3465H14.4805C15.9151 14.3635 19.4324 10.3976 25.9463 10.3976C31.6758 10.3976 35.6119 14.3635 36.8637 16.3465H33.5901C32.4352 15.1252 29.7549 12.8901 25.7801 12.8901C21.8053 12.8901 19.3576 14.743 17.7042 16.3465Z"
        fill="currentColor"
      />
      <rect
        x="32.3105"
        y="18.5233"
        width="2.75844"
        height="13.5429"
        fill="currentColor"
      />
      <rect
        x="16.3416"
        y="18.5233"
        width="2.75844"
        height="13.5429"
        fill="currentColor"
      />
    </svg>
  )
}
